// 控制台模块页面级国际化
export default {
    'workplace.greeting.midnight': '深夜好',
    'workplace.greeting.earlyMorning': '早上好',
    'workplace.greeting.noon': '中午好',
    'workplace.greeting.afternoon': '下午好',
    'workplace.greeting.evening': '晚上好',
    'workplace.date.sunday': '周日',
    'workplace.date.monday': '周一',
    'workplace.date.tuesday': '周二',
    'workplace.date.wednesday': '周三',
    'workplace.date.thursday': '周四',
    'workplace.date.friday': '周五',
    'workplace.date.saturday': '周六',
    'workplace.date.format': '{year}年{month}月{day}日',
    
    'workplace.stat.availableApps': '可用应用',
    'workplace.stat.tokenConsumption': 'Token 消耗',
    
    'workplace.recentApps.title': '常用应用',
    'workplace.recentApps.viewAll': '全部',
    'workplace.recentApps.empty.description': '暂无最近访问的应用，',
    'workplace.recentApps.empty.link': '去探索',
    'workplace.recentApps.noDescription': '暂无描述',
    
    'workplace.quickNav.title': '便捷导航',
    'workplace.quickNav.add': '添加',
    'workplace.quickNav.edit': '编辑快捷导航',
    'workplace.quickNav.addNew': '添加快捷导航',
    'workplace.quickNav.modal.title': '标题',
    'workplace.quickNav.modal.titlePlaceholder': '请输入标题',
    'workplace.quickNav.modal.link': '链接',
    'workplace.quickNav.modal.linkRequired': '请选择或输入链接',
    'workplace.quickNav.modal.menuTab': '选择菜单',
    'workplace.quickNav.modal.customTab': '自定义链接',
    'workplace.quickNav.modal.menuPlaceholder': '请选择菜单',
    'workplace.quickNav.modal.customPlaceholder': '请输入自定义链接，如 /dashboard/workplace',
    'workplace.quickNav.deleteConfirm.title': '确认删除',
    'workplace.quickNav.deleteConfirm.content': '确定要删除这个快捷导航吗？',
    'workplace.quickNav.deleteSuccess': '删除成功',
    'workplace.quickNav.editSuccess': '修改成功',
    'workplace.quickNav.addSuccess': '添加成功',
    
    'workplace.accessibleModules.title': '可访问模块',
    
    'workplace.profile.company': '公司',
    'workplace.profile.department': '部门',
    'workplace.profile.email': '邮箱',
    'workplace.nav.edit': '编辑',
    'workplace.nav.delete': '删除',
    'workplace.nav.add': '添加',
  };